import React from 'react';
import { BackButton } from '../../../../../Components/Utils/Buttons';
import ViewIcon from '../../../../../Components/Icons/ViewIcon';
import { Link, useParams } from 'react-router-dom';
import Breadcrumb from '../../../../../Components/Utils/Breadcrumb';
import { useFormik } from 'formik';

function ViewApprove() {
  const { viewIdsurvey } = useParams();

  const fireFightingSystemForms = [
    { id: 1, label: "Fire Protection System - Summary" },
    { id: 2, label: "Fire Pump" },
    { id: 3, label: "Fire Water Tanks" },
    { id: 4, label: "Fire / Foam Hose Cabinet" },
    { id: 5, label: "Fire / Foam Hose Cabinet Details" },
    { id: 6, label: "Fire Extinguisher" },
    { id: 7, label: "Fire Extinguisher Details" },
    { id: 8, label: "Clean Agent Fire Suppression System" },
    { id: 12, label: "Voice Evacuation System /Pava" },
    { id: 13, label: "Stand Pipe Hose System" },
    { id: 14, label: "Foam Fire Suppression System" },
    { id: 15, label: "Fire Hydrant" },
    { id: 16, label: "Kitchen Hood Fire Suppression Sys." },
    { id: 17, label: "Aerosol Fire Suppression System" },
  ];

  const fireAlarmSystemForms = [
    { id: 9, label: "Fire Alarm System" },
    { id: 10, label: "Aspirating Smoke Detection System" },
    { id: 11, label: "Asd System" },
  ];

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {}
  });

  // Choose form list based on viewIdsurvey param
  const selectedForms =
    viewIdsurvey === "1"
      ? fireFightingSystemForms
      : viewIdsurvey === "2"
      ? fireAlarmSystemForms
      : [];

  const heading =
    viewIdsurvey === "1"
      ? "Fire Fighting System"
      : viewIdsurvey === "2"
      ? "Fire Alarm System"
      : "No Forms Available";

  return (
    <div className="w-full h-full px-4 py-2 overflow-hidden">
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Forms Approve", link: `/settings/formsApprove/survey` },
            { name: "Forms" },
          ]}
        />
        <div className="flex justify-end">
          <BackButton />
        </div>
      </div>

      <div className="w-full h-[calc(100vh-145px)] bg-white mt-4 mx-auto rounded-md overflow-y-scroll">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full max-h-[calc(100vh-200px)] overflow-y-auto">
            {
              selectedForms.length > 0 ? (
                <div className="w-full p-4">
                  <h2 className="text-xl font-semibold mb-4">{heading}</h2>
                  <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {selectedForms.map((form) => (
                      <div key={form.id} className="mb-2 bg-slate-100 p-4 rounded-md shadow-sm hover:shadow-md transition-shadow text-xs flex items-center ">
                        <input type='checkbox' />
                        <Link
                          to={`/settings/formsApprove/survey/view/${viewIdsurvey}/${form.id}`}
                          className="text-baseColor-primary font-medium  flex items-center"
                        >
                          <span className="ml-2">{form.label}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="p-4 text-center text-gray-500">
                  No forms available for this survey.
                </div>
              )
            }
          </div>
        </form>
      </div>
    </div>
  );
}

export default ViewApprove;
